import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import {
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  Subject,
  switchMap,
} from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Popover, PopoverModule } from "primeng/popover";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { DatePickerModule } from "primeng/datepicker";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmationService } from "primeng/api";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { LoaderService } from "../../../core/services/loader.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { CustomerAccountService } from "../../../core/services/customer-account.service";
import { ClientSearchList } from "../../../core/models/shared/clientSearchList";
import { GetAllBuyersResponseDto } from "../../../core/models/orders/getAllBuyersResponseDto";
import { GetAllBuyersRequestDto } from "../../../core/models/orders/getAllBuyersRequestDto";
import { BuyerService } from "../../../core/services/buyer.service";
import { AddClientContact } from "../../../core/models/client/addClientContact";
import { InputTextModule } from "primeng/inputtext";
import { RadioButtonModule } from "primeng/radiobutton";
import { AddContactInformationComponent } from "../../clients/components/add-contact-information/add-contact-information.component";

@UntilDestroy()
@Component({
  selector: "jni-create-project-on-task",
  templateUrl: "./create-project-on-task.component.html",
  styleUrls: ["./create-project-on-task.component.scss"],
  providers: [ConfirmationService],
  imports: [
    TableModule,
    CommonModule,
    DatePickerModule,
    DialogModule,
    PopoverModule,
    ConfirmDialogModule,
    SelectModule,
    FormsModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    RadioButtonModule,
    FormsModule,
    AddContactInformationComponent,
  ],
})
export class CreateProjectOnTaskComponent implements OnInit {
  constructor(
    private _loaderService: LoaderService,
    private _workflowService: ProjectWorkflowService,
    private _toastr: JniToastrService,
    private _customerAccountService: CustomerAccountService,
    private _buyerService: BuyerService
  ) {}

  ngOnInit(): void {
    this.searchCustomerName();
  }

  showSmallLoader = false;
  customerIdD365 = "";
  jobName = "";
  buyerName = "";
  customerLists = [] as ClientSearchList[];
  buyerLists: GetAllBuyersResponseDto[] = [];
  public customerSearch$ = new Subject<string>();

  public buyerVendor$ = new Subject<string>();
  deliveryAddress = [
    {
      id: 1,
      name: "One Time",
      status: false,
    },
    {
      id: 2,
      name: "Bill To",
      status: false,
    },
    {
      id: 3,
      name: "Client Address Book",
      status: false,
    },
    {
      id: 4,
      name: "Multi Ship To",
      status: false,
    },
    {
      id: 5,
      name: "TBD",
      status: false,
    },
  ];
  @Output() closeModal = new EventEmitter();
  @Output() refreshProjectGrid = new EventEmitter<boolean>();
  displayAddContact = false;
  addClientContact: AddClientContact = {} as AddClientContact;

  onCustomerSearchOpenToggle(
    mydrop: Popover,
    event: KeyboardEvent,
    target: HTMLElement
  ) {
    mydrop.show(event, target);
  }

  searchCustomerName() {
    this.customerSearch$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }
          const accountNumberOrName = searchitem;
          this.customerLists = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._customerAccountService.getCustomerByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.customerLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getCustomerAccount(event: Event, mydrop: Popover) {
    const keyEvent = event as KeyboardEvent;
    const target = event.target as HTMLInputElement;
    this.showSmallLoader = true;
    if (keyEvent.key.toLowerCase() === "tab") {
      const countryValue = target.value;
      this._customerAccountService
        .getCustomerByNameAndAccountNumberFilter(countryValue)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.customerLists = res.data;
            if (this.customerLists.length > 0) {
              this.onClientSelection(this.customerLists[0], mydrop);
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onClientSelection(event: ClientSearchList, clientProspetToggle: Popover) {
    this.showSmallLoader = true;
    this.customerIdD365 = event.clientAccount;
    clientProspetToggle.hide();
    this.buyerName = "";
    this.buyerLists = [];
    this.getAllBuyers();
  }

  getAllBuyers() {
    const request = {
      clientAccountNumber: this.customerIdD365 || "",
      buyer: "",
    } as GetAllBuyersRequestDto;
    this._buyerService
      .getAllBuyers(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.buyerLists = res.data;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onBuyerSelection(
    event: GetAllBuyersResponseDto,
    buyerProspetToggle: Popover
  ) {
    this.buyerName = event.buyer;
    this.customerIdD365 = event.account;
    buyerProspetToggle.hide();
  }

  onContactList(
    contactdropdown: Popover,
    target: HTMLElement,
    event: MouseEvent
  ) {
    contactdropdown.show(event, target);
  }

  getBuyer(event: Event, mydrop: Popover) {
    this.showSmallLoader = true;
    const keyEvent = event as KeyboardEvent;
    const target = event.target as HTMLInputElement;
    if (keyEvent.key.toLowerCase() === "tab") {
      const countryValue = target.value;
      const payload = {
        clientAccountNumber: this.customerIdD365 ?? "",
        buyer: countryValue,
      } as GetAllBuyersRequestDto;
      this._buyerService
        .getAllBuyers(payload)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.buyerLists = res.data;
            if (this.buyerLists.length > 0) {
              this.onBuyerSelection(this.buyerLists[0], mydrop);
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onBuyerSearchOpenToggle(
    mydrop: Popover,
    event: KeyboardEvent,
    target: HTMLElement
  ) {
    mydrop.show(event, target);
    const element = event.target as HTMLInputElement;
    if (element?.value != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
  }

  onClienySearchList(
    clientListDropDown: Popover,
    event: MouseEvent,
    target: HTMLElement
  ) {
    clientListDropDown.show(event, target);
  }

  clearAddNewProjectModal() {
    this.customerIdD365 = "";
    this.jobName = "";
    this.buyerName = "";
    this.buyerLists = [];
    this.customerLists = [];
  }

  addNewProjectHeader() {
    this._loaderService.setLoaderState(true);
    if (!this.customerIdD365 || this.customerIdD365 === "") {
      this._toastr.error("Error", "Select a Client for Project");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (!this.jobName || this.jobName === "") {
      this._toastr.error("Error", "Enter Job Name for Project");
      this._loaderService.setLoaderState(false);
      return;
    }

    const request = {
      customerAccountNoD365: this.customerIdD365,
      jobName: this.jobName,
      buyerName: this.buyerName,
    };
    this._workflowService.addSampleWorkflowHeaderData(request).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.data) {
          this._toastr.success("Success", res.message);
          if (res.data.primaryBuyerWarning) {
            this._toastr.warning(res.data.primaryBuyerWarning);
          }
          this.refreshProjectGrid.emit(true);
          this.closeModal.emit();
          this.clearAddNewProjectModal();
        } else {
          this._toastr.error("Error", res.message);
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", res.message);
      },
    });
  }

  isContactAdded(obj: boolean) {
    if (obj) {
      this.getAllBuyers();
    }
  }

  populateContactAddedInfo(obj: string) {
    if (obj) {
      // this.parent.patchValue({
      //   orderHeader: {
      //     buyer: obj
      //   }
      // });
    }
  }

  addContactInformation() {
    this.addClientContact.firstName = "";
    this.addClientContact.lastName = "";
    this.addClientContact.type = "Buyer";
    this.displayAddContact = true;
  }

  changeClientAccount(eve: Event) {
    const target = eve.target as HTMLInputElement | null;
    const value = target?.value;
    if (!value) {
      this.customerIdD365 = "";
      this.buyerLists = [];
      this.buyerName = "";
    }
  }
}
